import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    dataBitrixChatBot: null,
    updateDataBitrixChatBot: null,
    newDataBitrixChatBot: null,
    activeDataBitrixChatBot: null,
    isUpdateBitrixChatBot: false,
    isLoadingBitrixChatBot: false,
    isErrorBitrixChatBot: false,
};

const bitrixChatBotSlice = createSlice({
    name: 'bitrixChatBot',
    initialState,
    reducers: {
        setDataBitrixChatBot(state, action) {
            state.dataBitrixChatBot = action.payload;
        },
        setNewDataBitrixChatBot(state, action) {
            state.newDataBitrixChatBot = action.payload;
        },
        setUpdateDataBitrixChatBot(state, action) {
            state.updateDataBitrixChatBot = action.payload;
        },
        setIsUpdateBitrixChatBot(state, action) {
            state.isUpdateBitrixChatBot = action.payload;
        },
        setActiveDataBitrixChatBot(state, action) {
            state.activeDataBitrixChatBot = action.payload;
        },
        setIsLoadingBitrixChatBot(state, action) {
            state.isLoadingBitrixChatBot = action.payload;
        },
        setIsErrorBitrixChatBot(state, action) {
            state.isErrorBitrixChatBot = action.payload;
        },
    },
});

export const {
    setDataBitrixChatBot,
    setNewDataBitrixChatBot,
    setUpdateDataBitrixChatBot,
    setIsUpdateBitrixChatBot,
    setActiveDataBitrixChatBot,
    setIsLoadingBitrixChatBot,
    setIsErrorBitrixChatBot,
} = bitrixChatBotSlice.actions;

export default bitrixChatBotSlice.reducer;
